import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import MinorProxyForm from '../components/minorProxyGigya/minorProxyForm'
import MinorProxyFormES from '../components/minorProxyFormES/minorFormES'
import MinorProxyFormZHCN from '../components/minorProxyFormZHCN/minorFormZHCN'
import EmailNotification from '../components/emailNotification/emailNotification'
import AdultProxyForm from '../components/adultproxyform/adultproxyform'
import AdultProxyFormES from '../components/adultproxyformES/adultproxyformES'
import AdultProxyFormZHCN from '../components/adultproxyformZHCN/adultproxyformZHCN'
import MinorProxyFormNoGigya from '../components/minorProxyForm/minorFormNoGigya'
import ThirteenToSeventeenMinorForm from '../components/thirteenToSeventeenMinorForm/thirteenToSeventeenMinorForm'
import PHQ2VerificationForm from '../components/PHQ2/verification-form'
import ErrorPage from '../components/errorpage/errorPage'
import envConfig from '../utils/configEnv/config'

const ToggleAdult = envConfig.REACT_APP_FEATURE_TOGGLE_ADULTPROXY
const ToggleNewMinorPage = envConfig.REACT_APP_FEATURE_TOGGLE_MINOR
const TogglePHQ2 = envConfig.REACT_APP_FEATURE_TOGGLE_PHQ2
const ToggleMinorPageES = envConfig.REACT_APP_FEATURE_TOGGLE_MINOR_ES?.trim() ? envConfig.REACT_APP_FEATURE_TOGGLE_MINOR_ES : true
const ToggleMinorPageZHCN = envConfig.REACT_APP_FEATURE_TOGGLE_MINOR_ZHCN?.trim() ? envConfig.REACT_APP_FEATURE_TOGGLE_MINOR_ZHCN : true
const ToggleAdultES = envConfig.REACT_APP_FEATURE_TOGGLE_ADULTPROXY_ES?.trim() ? envConfig.REACT_APP_FEATURE_TOGGLE_ADULTPROXY_ES : true
const ToggleAdultZHCN = envConfig.REACT_APP_FEATURE_TOGGLE_ADULTPROXY_ZHCN?.trim() ? envConfig.REACT_APP_FEATURE_TOGGLE_ADULTPROXY_ZHCN : true
const ToggleThirteenSeventeen = envConfig.REACT_APP_FEATURE_TOGGLE_THIRTEENSEVENTEEN?.trim() ? envConfig.REACT_APP_FEATURE_TOGGLE_THIRTEENSEVENTEEN : true

const ProtectedRoute = ({ element, condition }) => {
  return condition ? element : <Navigate to='/Error/403 Forbidden' replace />
}

const AppRoutes = () => (
  <Router basename='/'>
    <Routes>
      <Route path='/' element={<MinorProxyFormNoGigya />} />
      <Route path='/minorProxyFormCont/:id' element={<MinorProxyFormNoGigya />} />
      <Route path='/AdultProxyForm/:id?' element={<ProtectedRoute element={<AdultProxyForm />} condition={ToggleAdult === 'false'} />} />
      <Route path='/AdultProxyFormES/:id?' element={<ProtectedRoute element={<AdultProxyFormES />} condition={ToggleAdultES === 'false'} />} />
      <Route path='/AdultProxyFormZHCN/:id?' element={<ProtectedRoute element={<AdultProxyFormZHCN />} condition={ToggleAdultZHCN === 'false'} />} />
      <Route path='/MinorProxyForm/:id?' element={<ProtectedRoute element={<MinorProxyFormNoGigya />} condition={ToggleNewMinorPage === 'false'} />} />
      <Route path='/MinorProxyFormES/:id?' element={<ProtectedRoute element={<MinorProxyFormES />} condition={ToggleMinorPageES === 'false'} />} />
      <Route path='/MinorProxyFormZHCN/:id?' element={<ProtectedRoute element={<MinorProxyFormZHCN />} condition={ToggleMinorPageZHCN === 'false'} />} />
      <Route path='/PHQ2' element={<ProtectedRoute element={<PHQ2VerificationForm />} condition={TogglePHQ2 === 'false'} />} />
      <Route path='/ThirteenToSeventeenMinorForm/:id?' element={<ProtectedRoute element={<ThirteenToSeventeenMinorForm />} condition={ToggleThirteenSeventeen === 'false'} />} />
      <Route path='/EmailNotification/:email' element={<EmailNotification />} />
      {/* Eror Page Takes string Value for errormsg or code*/}
      <Route path='/Error/:error' element={<ErrorPage />} />
      {/*  Undefined Navigation Routes Request */}
      <Route path='*' element={<Navigate to='/Error/404 Not Found' replace />} />
    </Routes>
  </Router>
)

export default AppRoutes
